import React from 'react';
import {Route, IndexRoute, Redirect} from 'react-router';

import Layout from './pages/layout';
import Launch from './pages/launch'; // split landing page
import BrandAmbassadors from './pages/brand_ambassadors';
import BrandedContent from './pages/branded_content';
import ContentCreator from './pages/content_creator';
import Faq from './pages/faq';
import Jobs from './pages/jobs';
import VPOfEngineering from './pages/jobs_pages/vp_of_engineering';
import DataEngineer from './pages/jobs_pages/data_engineer';
import TalentSourcer from './pages/jobs_pages/talent_sourcer';
import FullStackEngineer from './pages/jobs_pages/full_stack_engineer';
import DirectorOfFinance from './pages/jobs_pages/director_of_finance';
import SalesDirector from './pages/jobs_pages/sales_director';
import RecruitingManager from './pages/jobs_pages/recruiting_manager';
import AccountManager from './pages/jobs_pages/account_manager';
import PrivacyPolicy from './pages/privacy_policy';
import Terms from './pages/terms/terms171107';
import NotFound from 'js/pages/not_found';

const routes = (
    <Route path="/" component={Layout}>
        <IndexRoute component={BrandedContent} />

        <Route path="/brand-ambassadors" component={BrandAmbassadors} />

        <Route path="/content_creator" component={ContentCreator} />
        <Route path="/faq" component={Faq} />
        <Route path="/jobs" component={Jobs} />
            <Route path="/jobs/vp_of_engineering" component={VPOfEngineering} />
            <Route path="/jobs/data_engineer" component={DataEngineer} />
            <Route path="/jobs/talent_sourcer" component={TalentSourcer} />
            <Route path="/jobs/full_stack_engineer" component={FullStackEngineer} />
            <Route path="/jobs/director_of_finance" component={DirectorOfFinance} />
            <Route path="/jobs/sales_director" component={SalesDirector} />
            <Route path="/jobs/recruiting_manager" component={RecruitingManager} />
            <Route path="/jobs/account_manager" component={AccountManager} />
        <Route path="/privacy" component={PrivacyPolicy} />
        <Route path="/terms" component={Terms} />
        <Redirect from="*" to="/" />
        <Route path="*" component={NotFound} />
    </Route>
);

export default routes;



// WEBPACK FOOTER //
// ./web/js/launch_routes.js